import React from 'react';
import type { UseFormRegister, FieldErrors, UseFormSetValue } from 'react-hook-form';
import type { CalculatorMode } from '../../types/tax';
import CalculationFormData, { type FormData } from './CalculationFormData';

interface IncomeInputFormProps {
  register: UseFormRegister<FormData>;
  errors: FieldErrors<FormData>;
  onSubmit: (e?: React.BaseSyntheticEvent) => Promise<void>;
  isCalculating: boolean;
  watchedValues: FormData;
  onReset: () => void;
  setValue: UseFormSetValue<FormData>;
  mode?: CalculatorMode;
}

export default function IncomeInputForm({ 
  register, 
  errors, 
  onSubmit, 
  isCalculating, 
  watchedValues,
  onReset,
  setValue,
  mode = 'reverse'
}: IncomeInputFormProps) {
  
  const isReverseMode = mode === 'reverse';
  const buttonText = isCalculating 
    ? 'Calculating...'
    : isReverseMode 
      ? 'Calculate Required Gross Income'
      : 'Calculate Take-Home Pay';
  
  const isSubmitDisabled = isCalculating || !watchedValues.income || !watchedValues.ageCategory;

  return (
    <form onSubmit={onSubmit} className="space-y-6">
      <CalculationFormData
        register={register}
        errors={errors}
        isCalculating={isCalculating}
        watchedValues={watchedValues}
        setValue={setValue}
        showPresets={true}
        showFrequencyToggle={true}
        mode={mode}
      />

      <div className="flex flex-col sm:flex-row gap-3">
        <button
          type="submit"
          disabled={isSubmitDisabled}
          className={`
            btn-primary flex-1 flex items-center justify-center
            ${isSubmitDisabled ? 'opacity-50 cursor-not-allowed' : ''}
          `}
        >
          {isCalculating ? (
            <>
              <svg className="animate-spin -ml-1 mr-2 h-4 w-4" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="m4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Calculating...
            </>
          ) : (
            buttonText
          )}
        </button>
        
        <button
          type="button"
          onClick={onReset}
          className="btn-secondary sm:w-auto"
          disabled={isCalculating}
        >
          Reset
        </button>
      </div>

    </form>
  );
}